export default {"src":"/_next/static/media/earnHive.e7025fdf.svg","height":729,"width":682,"blurWidth":0,"blurHeight":0};